import React, { useContext, useMemo } from 'react';
import PropTypes from 'prop-types';
import { svgSprite } from '../../wrappers';
import { generateCompStylers } from '../../../common/utils/styles';
import css from './AlertElement.module.scss';
import classnames from 'classnames';
import { UserProfileContext } from '../../../common/utils/getContext';
const AlertElement = ({ children, type, setShowAlert, compStyles }) => {
    const { stylers, classes } = generateCompStylers(compStyles);
    const { officePage, mainPage } = useContext(UserProfileContext);

    const img = useMemo(() => {
        switch (type) {
            case 'info':
                return officePage || mainPage ? 'question-circle-fill' : 'info-circle-fill';
            case 'success':
                return officePage || mainPage ? 'check-circle-fill' : 'check-circle';
            case 'warning':
                return 'warning-triangle-fill';
            case 'error':
                return 'warning-circle-fill';
        }
    }, [type, officePage, mainPage]);

    return (
        <div style={stylers.wrapper} className={classnames(css.alertWrapper, css[`alertWrapper--${type}`], classes.wrapper)}>
            <div style={stylers.alertImgBlock} className={classnames(css.alertImgBlock, classes.alertImgBlock)}>
                {svgSprite(img, {
                    width: '20px',
                    height: '20px',
                    style: stylers.alertImgBlockSvg,
                    className: classnames(css.alertImgBlockSvg, css[`alertImgBlockSvg--${type}`], classes.alertImgBlockSvg)
                })}
            </div>
            <div className={css.alertText}>{children}</div>
            {setShowAlert ? (
                <div onClick={() => setShowAlert(false)} style={stylers.crossWrapper} className={classes.crossWrapper}>
                    {svgSprite('cross', {
                        width: '9px',
                        height: '9px',
                        fill: 'var(--greyExtraDarkColor)',
                        className: css.crossSvg
                    })}
                </div>
            ) : null}
        </div>
    );
};

AlertElement.propTypes = {
    type: PropTypes.oneOf(['info', 'success', 'warning', 'error']),
    styles: PropTypes.object,
    setShowAlert: PropTypes.func
};

export default AlertElement;
